import { render, staticRenderFns } from "./Infograph_inner.vue?vue&type=template&id=f1b2cbf2&scoped=true"
import script from "./Infograph_inner.vue?vue&type=script&lang=js"
export * from "./Infograph_inner.vue?vue&type=script&lang=js"
import style0 from "./Infograph_inner.vue?vue&type=style&index=0&id=f1b2cbf2&prod&lang=css"
import style1 from "./Infograph_inner.vue?vue&type=style&index=1&id=f1b2cbf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b2cbf2",
  null
  
)

export default component.exports